import { riceGameDefaultPack, riceGamePacksById } from '@/config/riceGameAssetPacks';

function norm(s) {
  return String(s || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

/**
 * Сопоставление строки title / rice_type с ключом пака из riceGamePacksById.
 * Добавьте новые варианты сюда или расширьте `matchTitles` в конфиге.
 */
export function resolveRiceGamePackId(gameRow) {
  const title = norm(gameRow?.title);
  const riceType = norm(gameRow?.rice_type);

  const hay = `${title} ${riceType}`;

  const entries = Object.values(riceGamePacksById);
  for (let i = 0; i < entries.length; i += 1) {
    const pack = entries[i];
    const needles = pack.matchTitles || [];
    for (let j = 0; j < needles.length; j += 1) {
      if (hay.includes(norm(needles[j]))) {
        return pack.id;
      }
    }
  }

  if (/бирияни|biryani/i.test(hay)) return 'biryani';
  if (/узбек/i.test(hay)) return 'uzbek';
  if (/турец/i.test(hay)) return 'turkish';
  if (/восточн/i.test(hay)) return 'vostochniy';
  if (/чайхан/i.test(hay)) return 'chayhanskiy';
  if (/домашн/i.test(hay)) return 'domashniy';

  return riceGameDefaultPack.id;
}

function coalesceUrl(primary, fallback) {
  return primary != null && primary !== '' ? primary : fallback;
}

/**
 * @param {Record<string, unknown>|null|undefined} gameRow — activeRiceGame (title, rice_type, …)
 * @returns {{
 *   id: string,
 *   backgroundDesktop: string,
 *   backgroundMobile: string,
 *   backgroundDesktop2x: string|null,
 *   backgroundMobile2x: string|null,
 *   introBackgroundDesktop: string,
 *   introBackgroundMobile: string,
 *   introBackgroundDesktop2x: string|null,
 *   introBackgroundMobile2x: string|null,
 *   frames: string[],
 *   framesMobile: string[]|null,
 * }}
 */
export function resolveRiceGameAssetPack(gameRow) {
  const packId = resolveRiceGamePackId(gameRow || {});
  const raw = riceGamePacksById[packId] || {};

  const backgroundDesktop = coalesceUrl(raw.backgroundDesktop, riceGameDefaultPack.backgroundDesktop);
  const backgroundMobile = coalesceUrl(raw.backgroundMobile, riceGameDefaultPack.backgroundMobile);

  const backgroundDesktop2x =
    raw.backgroundDesktop2x != null && raw.backgroundDesktop2x !== '' ? raw.backgroundDesktop2x : null;
  const backgroundMobile2x =
    raw.backgroundMobile2x != null && raw.backgroundMobile2x !== '' ? raw.backgroundMobile2x : null;

  const frames =
    Array.isArray(raw.frames) && raw.frames.length > 0
      ? [...raw.frames]
      : [...riceGameDefaultPack.frames];

  const framesMobile =
    Array.isArray(raw.framesMobile) && raw.framesMobile.length > 0 ? [...raw.framesMobile] : null;

  const introBackgroundDesktop =
    raw.introBackgroundDesktop != null && raw.introBackgroundDesktop !== ''
      ? raw.introBackgroundDesktop
      : backgroundDesktop;
  const introBackgroundMobile =
    raw.introBackgroundMobile != null && raw.introBackgroundMobile !== ''
      ? raw.introBackgroundMobile
      : backgroundMobile;

  const introBackgroundDesktop2x =
    raw.introBackgroundDesktop2x != null && raw.introBackgroundDesktop2x !== ''
      ? raw.introBackgroundDesktop2x
      : backgroundDesktop2x;
  const introBackgroundMobile2x =
    raw.introBackgroundMobile2x != null && raw.introBackgroundMobile2x !== ''
      ? raw.introBackgroundMobile2x
      : backgroundMobile2x;

  return {
    id: raw.id || packId,
    backgroundDesktop,
    backgroundMobile,
    backgroundDesktop2x,
    backgroundMobile2x,
    introBackgroundDesktop,
    introBackgroundMobile,
    introBackgroundDesktop2x,
    introBackgroundMobile2x,
    frames,
    framesMobile,
  };
}
